import { dsl } from '@wix/yoshi-serverless/wrap';

export const resolveCommentDeepLink = dsl({
          functionName: 'resolveCommentDeepLink',
          fileName: 'api/comments/resolve-comment-deep-link.api',
        });